export default __webpack_public_path__ + "static/media/06_ANTS.db963e3a.png";